export const PRIMARY_CARE_PHYSICIAN_OPTIONS = {
  FULL_NAME: "Patient.PrimaryCarePhysician.FullName",
  NPI: "Patient.PrimaryCarePhysician.NPI",
  EMAIL: "Patient.PrimaryCarePhysician.Email",
  PHONE: "Patient.PrimaryCarePhysician.Phone",
  FAX_NUMBER: "Patient.PrimaryCarePhysician.FaxPhone",
  PRACTICE_NAME: "Patient.PrimaryCarePhysician.PracticeName",
  ADDRESS: "Patient.PrimaryCarePhysician.Address",
};
